<template>
  <label
    v-if="label"
    :for="id"
    class="block text-sm font-semibold dark:text-white"
    :class="{ 'text-red-500': isError }"
    >{{ label }}
    <span class="text-red-500">{{ required ? '*' : '' }}</span></label
  >
  <div class="relative">
    <div
      v-if="preIcon"
      class="absolute inset-y-0 inset-s-0 flex items-center pointer-events-none ps-4 peer-disabled:opacity-50 peer-disabled:pointer-events-none"
    >
      <component
        :is="iconos[preIcon as IconName]"
        class="shrink-0 size-4 text-gray-400 dark:text-white/60"
      >
      </component>
    </div>
    <input
      v-if="$attrs.type != 'password'"
      v-bind="$attrs"
      :id="id"
      v-model="model"
      aria-haspopup="false"
      autocapitalize="off"
      autocomplete="off"
      autocorrect="off"
      :maxlength="maxlength"
      :class="[
        typeOfInput[$attrs.type as string]
          ? typeOfInput[$attrs.type as string]
          : '',
        sizes[size],
        $attrs.type == 'checkbox' ? '' : colors[color],
        $attrs.type == 'checkbox' ? typesInput.checkbox : typesInput[typeInput],
        $attrs.type != 'checkbox' && typeInput === 'default' && (!props.estiloActivoReadonly || $attrs.disabled)
          ? 'read-only:bg-gray-100 read-only:text-gray-400 dark:read-only:bg-slate-800 dark:read-only:text-gray-400'
          : '',
        $attrs.type == 'checkbox' ? '' : styleInputs[styleInput],
        isError ? 'border-red-500 ring-red-500 ' : '',
        $attrs.type == 'checkbox' ? '' : 'w-full',
        upperCase ? 'uppercase-input' : '',
        classAdd ? classAdd : ''
      ]"
      v-on="eventHandlers"
      @paste="onPaste"
      @wheel="onWheel"
    />
    <div v-if="$attrs.type == 'password'" class="flex mb-2">
      <div class="flex-1">
        <input
          v-bind="$attrs"
          :id="id"
          v-model="model"
          aria-haspopup="false"
          autocapitalize="off"
          autocomplete="off"
          autocorrect="off"
          :maxlength="maxlength"
          :class="[
            typeOfInput[$attrs.type as string]
              ? typeOfInput[$attrs.type as string]
              : '',
            sizes[size],
            colors[color],
            typesInput[typeInput],
            typeInput === 'default' && (!props.estiloActivoReadonly || $attrs.disabled)
              ? 'read-only:bg-gray-100 read-only:text-gray-400 dark:read-only:bg-slate-800 dark:read-only:text-gray-400'
              : '',
            styleInputs[styleInput],
            isError ? 'border-red-500 ring-red-500 ' : '',
            $attrs.type == 'checkbox' ? '' : 'w-full'
          ]"
        />
        <div
          :id="strongPasswordId"
          :data-hs-strong-password="strongPasswordConfig"
          class="flex mt-2 -mx-1"
        ></div>
      </div>
      <button
        type="button"
        :data-hs-toggle-password="togglePasswordConfig"
        class="ms-2 inline-flex shrink-0 justify-center items-center h-12 w-12 rounded-md border font-medium bg-white text-gray-700 shadow-sm align-middle hover:bg-gray-50 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-offset-white focus:ring-blue-600 transition-all dark:bg-neutral-900 dark:hover:bg-neutral-800 dark:border-neutral-700 dark:text-neutral-400 dark:hover:text-white dark:focus:ring-offset-neutral-900"
      >
        <EyeIcon class="hs-password-active:hidden shrink-0 size-3.5" />
        <EyeSlashIcon
          class="hidden hs-password-active:block shrink-0 size-3.5"
        />
      </button>
    </div>
    <slot name="limpiar" :estilo="sizesClear[size]">
    <button
      v-if="
        (clear || enableCopyPaste) &&
        ($attrs.value || model) &&
        !$attrs.disabled &&
        !$attrs.readonly
      "
      type="button"
      aria-label="Limpiar campo"
      class="cursor-pointer absolute shrink-0 size-6 flex items-center justify-center rounded-md border border-transparent bg-blue-50 hover:bg-blue-100 disabled:opacity-50 disabled:pointer-events-none"
      :class="$attrs.readonly && !props.estiloActivoReadonly ? 'text-gray-400' : 'text-blue-600'"
      :style="sizesClear[size]"
      @click="cleanModel()"
    >
      <XMarkIcon class="size-4" />
    </button>
    </slot>
    <div
      v-if="enableCopyPaste && (model || $attrs.value) && !$attrs.disabled"
      class="absolute flex"
      :style="sizesCopy[size]"
    >
      <TooltipDefault description="Copiar">
        <div
          class="cursor-pointer shrink-0 size-6 flex items-center justify-center rounded-md border border-transparent bg-blue-50 hover:bg-blue-100"
          aria-label="Copiar"
          @click="copyToClipboard"
        >
          <ClipboardDocumentIcon
            class="size-4"
            :class="$attrs.readonly && !props.estiloActivoReadonly ? 'text-gray-400' : 'text-blue-600'"
          />
        </div>
      </TooltipDefault>
    </div>
    <div
      v-if="enableCopyPaste && !$attrs.value && !model && !$attrs.disabled"
      class="absolute flex"
      :style="sizesPaste[size]"
    >
      <TooltipDefault description="Pegar">
        <div
          class="cursor-pointer shrink-0 size-6 flex items-center justify-center rounded-md border border-transparent bg-blue-50 hover:bg-blue-100"
          aria-label="Pegar"
          @click="pasteFromClipboard"
        >
          <ClipboardIcon
            class="size-4"
            :class="$attrs.readonly && !props.estiloActivoReadonly ? 'text-gray-400' : 'text-blue-600'"
          />
        </div>
      </TooltipDefault>
    </div>
    <IconErrorTag :is-error="isError" />
  </div>
  <ErrorTag
    :is-error="isError"
    :model="model"
    :required="required"
    :error-message="errorMessage"
  />
  <template v-if="$attrs.type == 'password'">
    <div :id="hintsId" class="mb-3">
      <div>
        <span class="text-sm text-gray-800 dark:text-neutral-200">Nivel:</span>
        <span
          data-hs-strong-password-hints-weakness-text='["Vacio", "Debil", "Medio", "Fuerte", "Muy fuerte", "Super fuerte"]'
          class="text-sm font-semibold text-gray-800 dark:text-neutral-200"
        ></span>
      </div>
      <h4 class="my-2 text-sm font-semibold text-gray-800 dark:text-white">
        La contraseña debe contener:
      </h4>
      <ul class="space-y-1 text-sm text-gray-500">
        <li
          data-hs-strong-password-hints-rule-text="min-length"
          class="hs-strong-password-active:text-teal-500 flex items-center gap-x-2"
        >
          <span class="hidden" data-check>
            <svg
              class="shrink-0 size-4"
              xmlns="http://www.w3.org/2000/svg"
              width="24"
              height="24"
              viewBox="0 0 24 24"
              fill="none"
              stroke="currentColor"
              stroke-width="2"
              stroke-linecap="round"
              stroke-linejoin="round"
            >
              <polyline points="20 6 9 17 4 12" />
            </svg>
          </span>
          <span data-uncheck>
            <svg
              class="shrink-0 size-4"
              xmlns="http://www.w3.org/2000/svg"
              width="24"
              height="24"
              viewBox="0 0 24 24"
              fill="none"
              stroke="currentColor"
              stroke-width="2"
              stroke-linecap="round"
              stroke-linejoin="round"
            >
              <path d="M18 6 6 18" />
              <path d="m6 6 12 12" />
            </svg>
          </span>
          Minimo 6 caracteres.
        </li>
        <li
          data-hs-strong-password-hints-rule-text="lowercase"
          class="hs-strong-password-active:text-teal-500 flex items-center gap-x-2"
        >
          <span class="hidden" data-check>
            <svg
              class="shrink-0 size-4"
              xmlns="http://www.w3.org/2000/svg"
              width="24"
              height="24"
              viewBox="0 0 24 24"
              fill="none"
              stroke="currentColor"
              stroke-width="2"
              stroke-linecap="round"
              stroke-linejoin="round"
            >
              <polyline points="20 6 9 17 4 12" />
            </svg>
          </span>
          <span data-uncheck>
            <svg
              class="shrink-0 size-4"
              xmlns="http://www.w3.org/2000/svg"
              width="24"
              height="24"
              viewBox="0 0 24 24"
              fill="none"
              stroke="currentColor"
              stroke-width="2"
              stroke-linecap="round"
              stroke-linejoin="round"
            >
              <path d="M18 6 6 18" />
              <path d="m6 6 12 12" />
            </svg>
          </span>
          Debe contener una letra minuscula.
        </li>
        <li
          data-hs-strong-password-hints-rule-text="uppercase"
          class="hs-strong-password-active:text-teal-500 flex items-center gap-x-2"
        >
          <span class="hidden" data-check>
            <svg
              class="shrink-0 size-4"
              xmlns="http://www.w3.org/2000/svg"
              width="24"
              height="24"
              viewBox="0 0 24 24"
              fill="none"
              stroke="currentColor"
              stroke-width="2"
              stroke-linecap="round"
              stroke-linejoin="round"
            >
              <polyline points="20 6 9 17 4 12" />
            </svg>
          </span>
          <span data-uncheck>
            <svg
              class="shrink-0 size-4"
              xmlns="http://www.w3.org/2000/svg"
              width="24"
              height="24"
              viewBox="0 0 24 24"
              fill="none"
              stroke="currentColor"
              stroke-width="2"
              stroke-linecap="round"
              stroke-linejoin="round"
            >
              <path d="M18 6 6 18" />
              <path d="m6 6 12 12" />
            </svg>
          </span>
          Debe contener una letra mayuscula.
        </li>
        <li
          data-hs-strong-password-hints-rule-text="numbers"
          class="hs-strong-password-active:text-teal-500 flex items-center gap-x-2"
        >
          <span class="hidden" data-check>
            <svg
              class="shrink-0 size-4"
              xmlns="http://www.w3.org/2000/svg"
              width="24"
              height="24"
              viewBox="0 0 24 24"
              fill="none"
              stroke="currentColor"
              stroke-width="2"
              stroke-linecap="round"
              stroke-linejoin="round"
            >
              <polyline points="20 6 9 17 4 12" />
            </svg>
          </span>
          <span data-uncheck>
            <svg
              class="shrink-0 size-4"
              xmlns="http://www.w3.org/2000/svg"
              width="24"
              height="24"
              viewBox="0 0 24 24"
              fill="none"
              stroke="currentColor"
              stroke-width="2"
              stroke-linecap="round"
              stroke-linejoin="round"
            >
              <path d="M18 6 6 18" />
              <path d="m6 6 12 12" />
            </svg>
          </span>
          Debe contener numeros.
        </li>
        <li
          data-hs-strong-password-hints-rule-text="special-characters"
          class="hs-strong-password-active:text-teal-500 flex items-center gap-x-2"
        >
          <span class="hidden" data-check>
            <svg
              class="shrink-0 size-4"
              xmlns="http://www.w3.org/2000/svg"
              width="24"
              height="24"
              viewBox="0 0 24 24"
              fill="none"
              stroke="currentColor"
              stroke-width="2"
              stroke-linecap="round"
              stroke-linejoin="round"
            >
              <polyline points="20 6 9 17 4 12" />
            </svg>
          </span>
          <span data-uncheck>
            <svg
              class="shrink-0 size-4"
              xmlns="http://www.w3.org/2000/svg"
              width="24"
              height="24"
              viewBox="0 0 24 24"
              fill="none"
              stroke="currentColor"
              stroke-width="2"
              stroke-linecap="round"
              stroke-linejoin="round"
            >
              <path d="M18 6 6 18" />
              <path d="m6 6 12 12" />
            </svg>
          </span>
          Debe contener caracteres especiales.
        </li>
      </ul>
    </div>
  </template>
  <template
    v-if="
      showCharacterCount &&
      maxlength &&
      model &&
      typeof model === 'string' &&
      maxlength >= model.length
    "
  >
    <span class="text-xs" :class="getCharacterCountColor">
      {{ model?.length }} de {{ maxlength }}
    </span>
  </template>
</template>

<script setup lang="ts">
import { computed, onMounted, useAttrs } from 'vue'
import { EyeIcon, EyeSlashIcon } from '@heroicons/vue/24/solid'
import * as iconos from '@heroicons/vue/24/outline'
import type { IconName } from '@/modules/Core/interfaces'
import { XMarkIcon } from '@heroicons/vue/24/outline'
import { ClipboardIcon, ClipboardDocumentIcon } from '@heroicons/vue/24/outline'
import type { ModelValue } from '@/modules/Core/usings/constantes'
import { getEventHandlers, getIsError, generarUuid, copiarAPortapapeles } from '@/modules/Core/usings/generales'
import type { ErrorObject } from '@vuelidate/core'
import TooltipDefault from '../general/TooltipDefault.vue'
import type { IConfCompxfuncion } from '@/modules/Administracion/interfaces'
const model = defineModel<ModelValue>()
const attrs = useAttrs()
const emit = defineEmits<{
  paste: [value: string]
}>()

const props = defineProps<{
  id?: string
  label?: string
  clear?: boolean
  estiloActivoReadonly?: boolean
  clearEvent?: () => void
  color?: string
  typeInput?: string
  size?: string
  preIcon?: string
  required?: boolean
  styleInput?: string
  error?: string | Array<ErrorObject> | null | undefined
  upperCase?: boolean
  compxfunciones?: IConfCompxfuncion[]
  classAdd?: string
  maxlength?: number
  showCharacterCount?: boolean
  enableCopyPaste?: boolean
}>()
const {
  id = generarUuid(),
  label,
  clear = false,
  color = 'default',
  typeInput = 'default',
  size = 'default',
  preIcon,
  styleInput = 'default',
  required = false,
  upperCase = false,
  maxlength,
  showCharacterCount = false,
  enableCopyPaste = false
} = props
const errorMessage = computed(() => props.error)

const eventHandlers = computed(() => {
  let handlers: Record<string, (e: Event) => void> = {}
  if (props.compxfunciones) {
    const compxfunciones =
      typeof props.compxfunciones === 'string'
        ? JSON.parse(props.compxfunciones)
        : props.compxfunciones
    if (compxfunciones.length > 0) {
      handlers = getEventHandlers(compxfunciones)
    }
  }
  return handlers
})
const isError = computed(() => {
  const isArray = Array.isArray(props.error)
  return getIsError(props, isArray)
})

// Computed para el color del contador de caracteres
const getCharacterCountColor = computed(() => {
  if (!maxlength || !model.value || typeof model.value !== 'string') {
    return 'text-gray-700'
  }

  const currentLength = model.value.length
  const percentage = (currentLength / maxlength) * 100

  if (percentage >= 90) {
    return 'text-green-500' // Verde cuando está al 90% o más
  } else if (percentage >= 60) {
    return 'text-yellow-500' // Amarillo cuando está al 60% o más
  } else {
    return 'text-gray-700' // Gris por defecto
  }
})
const cleanModel = () => {
  model.value = ''
  if (props.clearEvent) props.clearEvent()
}
const copyToClipboard = async () => {
  if (model.value) {
    try {
      await copiarAPortapapeles(model.value as string)
      window.notificacion.notificacion(
        'success',
        'Texto copiado al portapapeles.'
      )
    } catch (err) {
      console.error('Failed to copy:', err)
    }
  }
}
const pasteFromClipboard = async () => {
  // navigator.clipboard.readText solo existe en contextos seguros (HTTPS/localhost)
  // y no tiene respaldo posible: se avisa en vez de romper.
  if (!navigator.clipboard?.readText) {
    window.notificacion.notificacion(
      'warning',
      'Pegar desde el portapapeles requiere HTTPS. Use Ctrl+V.'
    )
    return
  }
  try {
    const text = await navigator.clipboard.readText()
    emit('paste', text)
  } catch (err) {
    console.error('Failed to paste:', err)
  }
}

const onWheel = (e: WheelEvent) => {
  if (attrs.type === 'number') {
    (e.target as HTMLInputElement).blur()
  }
}

const onPaste = (e: ClipboardEvent) => {
  if (!props.enableCopyPaste) return
  e.preventDefault()
  let text = e.clipboardData?.getData('text')

  if (!text && e.clipboardData) {
    const html = e.clipboardData.getData('text/html')
    if (html) {
      const tempDiv = document.createElement('div')
      tempDiv.innerHTML = html
      text = tempDiv.textContent || tempDiv.innerText || ''
    }
  }

  text = text?.trim() || ''
  if (!attrs.readonly && !attrs.disabled) model.value = text
  emit('paste', text)
}

const sizes = {
  small: 'py-2 px-3 ' + (preIcon ? 'ps-10 ' : ''),
  default: 'py-2 px-3 ' + (preIcon ? ' ps-10 ' : ''),
  medium: 'py-3 px-4 ' + (preIcon ? ' ps-10 ' : ''),
  large: 'p-4 sm:p-5 ' + (preIcon ? ' ps-10  ' : '')
} as Record<string, string>
const sizesClear = {
  small: ' right: 20px; top: 50%; transform: translateY(-50%)',
  default: ' right: 10px; top: 50%; transform: translateY(-50%)',
  medium: ' right: 20px; top: 50%; transform: translateY(-50%)',
  large: ' right: 20px; top: 50%; transform: translateY(-50%)'
} as Record<string, string>
const sizesCopy = {
  small: ' right: 50px; top: 50%; transform: translateY(-50%)',
  default: ' right: 40px; top: 50%; transform: translateY(-50%)',
  medium: ' right: 50px; top: 50%; transform: translateY(-50%)',
  large: ' right: 50px; top: 50%; transform: translateY(-50%)'
} as Record<string, string>
const sizesPaste = {
  small: ' right: 20px; top: 50%; transform: translateY(-50%)',
  default: ' right: 10px; top: 50%; transform: translateY(-50%)',
  medium: ' right: 20px; top: 50%; transform: translateY(-50%)',
  large: ' right: 20px; top: 50%; transform: translateY(-50%)'
} as Record<string, string>
const colors = {
  default: ' focus:border-blue-500 focus:ring-blue-500 ',
  red: ' focus:border-red-500 focus:ring-red-500 ',
  blue: ' focus:border-blue-500 focus:ring-blue-500 ',
  green: ' focus:border-green-500 focus:ring-green-500 ',
  yellow: ' focus:border-yellow-500 focus:ring-yellow-500 '
} as Record<string, string>

const typesInput = {
  default:
    ' form-input block border-gray-600 rounded text-sm disabled:bg-gray-100 disabled:text-gray-400 disabled:pointer-events-none dark:bg-slate-900 dark:border-gray-700 dark:text-gray-400 dark:focus:ring-gray-600 dark:disabled:bg-slate-800 dark:disabled:text-gray-400 ',
  grayinput:
    ' form-input peer  ps-11 block bg-gray-100 border-transparent rounded text-sm disabled:opacity-50 disabled:pointer-events-none dark:bg-gray-700 dark:border-transparent dark:text-gray-400 dark:focus:ring-gray-600 ',
  checkbox:
    ' form-checkbox cursor-pointer peer h-4 w-4 rounded bg-white border-gray-400 text-blue-600 disabled:pointer-events-none disabled:bg-gray-100 disabled:border-gray-200 disabled:text-gray-300 dark:bg-gray-800 dark:border-gray-500 dark:text-blue-500 dark:focus:ring-gray-600 dark:disabled:bg-gray-700 dark:disabled:border-gray-700 dark:disabled:text-gray-600 ',
  checkboxDelete:
    ' form-checkbox peer h-4 w-4 text-red-500 border-gray-400 rounded disabled:opacity-50 disabled:pointer-events-none dark:bg-gray-700 dark:border-gray-700 dark:text-gray-400 dark:focus:ring-gray-600 hover:border-red-400 hover:bg-red-50 '
} as Record<string, string>

const styleInputs = {
  default: '',
  login: ' bg-white/90 border-transparent rounded-lg'
} as Record<string, string>

const typeOfInput = {
  textarea: 'form-textarea',
  multiple: 'form-multiselect',
  checkbox: 'form-checkbox',
  radio: 'form-radio'
}
const strongPasswordId = computed(() => `hs-strong-password-${id}`)
const hintsId = computed(() => `hs-strong-password-hints-${id}`)

const strongPasswordConfig = computed(() => {
  return JSON.stringify({
    target: `#${id}`,
    hints: `#${hintsId.value}`,
    stripClasses:
      'hs-strong-password:opacity-100 hs-strong-password-accepted:bg-teal-500 h-2 flex-auto rounded-full bg-blue-500 opacity-50 mx-1'
  })
})

const togglePasswordConfig = computed(() => {
  return JSON.stringify({
    target: `#${id}`
  })
})

onMounted(async () => {
  if (attrs.type === 'password') {
    setTimeout(() => {
      const strongPasswordElement = document.getElementById(
        strongPasswordId.value
      )
      if (strongPasswordElement && window.HSStrongPassword) {
        new window.HSStrongPassword(strongPasswordElement)
      }

      const togglePasswordElement = document.querySelector(
        `[data-hs-toggle-password='${togglePasswordConfig.value}']`
      )
      if (togglePasswordElement && window.HSTogglePassword) {
        new window.HSTogglePassword(togglePasswordElement as HTMLElement)
      }
    }, 100)
  }
})

// Declaración corregida para las bibliotecas globales de Preline UI
declare global {
  interface Window {
    HSStrongPassword: new (element: HTMLElement) => unknown
    HSTogglePassword: new (element: HTMLElement) => unknown
  }
}
</script>

<style>
.uppercase-input {
  text-transform: uppercase;
}

input[type='number']::-webkit-outer-spin-button,
input[type='number']::-webkit-inner-spin-button {
  -webkit-appearance: none;
  margin: 0;
}

input[type='number'] {
  appearance: textfield;
  -moz-appearance: textfield;
}
</style>
